import { createContext } from 'react';

// Dynamic menu routes carry their exact database menu identity to nested file controls.
export const FileActionMenuContext = createContext<number | undefined>(undefined);
